<script>
	const Q = require('q');
	var Grading = require('../../../readworks-grading');
	var userContext = require('core/userContext');
	var _ = require('underscore');
	var scrollManager = require('ui/core/scrollManager');
	var QuestionNavMixin = require('./question-nav-mixin');

	const assignmentService = require('services/assignmentService');
	const utilities = require('utilities');
	const getWordCount = utilities.getWordCount;

	const classBOKUtilities = require('utilities/classBOKUtilities');
	const getStudentCbokEntries = classBOKUtilities.getStudentEntries;

	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		mixins: [QuestionNavMixin],
		components: {
			'validated-textarea': require('components/validated-textarea.vue').default,
			'vocabulary-image-list': require('components/vocabulary-image-list.vue').default,
			'book-of-knowledge-assignment': require('components/book-of-knowledge-assignment.vue').default,
			'book-of-knowledge-entry': require('components/book-of-knowledge-entry.vue').default,
			'bbok-badge-icon': require('components/svg/bbok-badge-icon.vue').default,
			'bok-bookmark-icon': require('components/svg/bok-bookmark-icon.vue').default,
			'bok-note': require('components/bok-note.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		props: [
			'question-sets-ordered-and-filtered',
			'workspace',
			'product',
			'questions-blurb',
			'assignment-id',
			'scored-question-sets',
			'assignment',
			'markedDone'
		],
		modelData: ['activeClass', 'studentCbok', 'resultsQset'],
		data: function () {
			return {
				qsetTabKey: 'resultsQset',
				wordsWritten: 0,
				wordsRead: 0,
				articlesRead: 0,
				totalWords: 0,
				summaryByQsid: {},
				studentName: '',
				titleMap: {},
				bokRevisionProductId: null,
				bokRevisionContent: null,
				bokProductId: null,
				bokContent: null,
				studentCbokLoading: false
			};
		},
		mounted() {
			this.studentName = userContext.getFullName();
			let activeClass = this.activeClass;

			this.studentCbokLoading = true;
			getStudentCbokEntries(activeClass.cc).finally(() => (this.studentCbokLoading = false));

			this.$watch('workspace', _.bind(this.doSummaries, this), {
				deep: true
			});
			this.$watch('product', _.bind(this.doSummaries, this), {
				deep: true
			});
			this.$watch('scoredQuestionSets', _.bind(this.doSummaries, this), {
				deep: true,
				immediate: true
			});
		},
		methods: {
			scrollToNote: function (index) {
				scrollManager(
					$('[data-note=' + index + ']'),
					{
						duration: 500,
						priority: 0
					},
					this.$el
				);
			},
			doSummaries: function () {
				var self = this;
				var summaryByQsid = {};
				// Submitted January 21, 2016
				// Multiple choice 3/6 (50%)
				// Written Response 1.75/3 (58%)
				// Total 4.75/9 (53%)
				if (self.scoredQuestionSets) {
					_.each(self.product.questionSets, function (qs, qsid) {
						summaryByQsid[qsid] = Grading.studentAssessmentSummary(
							self.workspace.uid,
							qsid,
							self.scoredQuestionSets[qsid],
							self.product,
							self.workspace.opts
						);
					});
				}

				var product = self.product,
					workspace = self.workspace,
					titleMap = {};

				if (workspace && product && product.productType === 'AAD') {
					for (var key in workspace.scoreState.a) {
						titleMap[key] = product.allArticles[key].title;
					}

					self.titleMap = titleMap;

					var wordsWritten = 0,
						wordsRead = 0,
						articlesRead = 0,
						totalWords = 0,
						articles = self.articleList || [];

					articles.forEach(article => {
						totalWords += article.wordCount;
						var entry = workspace.scoreState.a[article.uuid];

						if (!entry) {
							return;
						}

						if (entry.b) {
							wordsWritten += getWordCount(entry.b);
						}
						if (entry.brev) {
							wordsWritten += getWordCount(entry.brev);
						}

						if (entry.s === 's') {
							wordsRead += article.wordCount;
							articlesRead++;
						}
					});

					self.wordsWritten = wordsWritten;
					self.wordsRead = wordsRead;
					self.articlesRead = articlesRead;
					self.totalWords = totalWords;
				}

				self.summaryByQsid = summaryByQsid;
			},
			hasNote: function (qsId) {
				for (var key in this.workspace.scoreState.q[qsId]) {
					if (this.workspace.scoreState.q[qsId][key].f) {
						return true;
					}
				}

				return false;
			},
			editBoKEntry(entry, bok, persist, editRevision) {
				let ts = Date.now() / 1000;
				let endpointName = 'reviseBookOfKnowledge';
				let contentKey = 'brev';
				let tsKey = 'brevts';
				let pid = entry ? entry.pid : null;
				let aid = entry ? entry.aid : null;
				let updatedData = {};
				let prms = Q();

				if (!editRevision) {
					endpointName = 'editBookOfKnowledge';
					contentKey = 'b';
					tsKey = 'bets';
				}

				// persisting to memory cause re-rendering of the entry component
				// only to be done on submit
				if (persist) {
					updatedData[contentKey] = bok;
					updatedData[tsKey] = ts;

					this.workspace.scoreState.a[pid] = _.assign({}, this.workspace.scoreState.a[pid], updatedData);
				} else {
					// persisting to service is done on ever change event
					prms = assignmentService[endpointName]({
						aid,
						pid,
						bok
					});
				}

				return prms;
			},
			assetUrl(url) {
				return assetUrl(url);
			}
		},
		computed: {
			assignmentPastDue: function () {
				let assignment = this.assignment;
				let duedate = assignment.edd || assignment.deadline;
				let now = new Date() / 1000;
				let pastDue = false;

				if (duedate && duedate < now) {
					pastDue = true;
				}

				return pastDue;
			},
			editBoKInline() {
				return this.activeClass.as.bokEdit;
			},
			bookOfKnowledgeAssignment() {
				let product = this.product;
				let workspace = this.workspace;
				let assignment = this.assignment;
				let pastDue = this.assignmentPastDue;
				let inlineEdit = this.editBoKInline;
				let bokAssignment = null;

				let studentCbok = this.studentCbok;
				let assignmentId = this.assignmentId;
				let cbokEntriesByArticle = {};

				if (studentCbok && assignmentId && studentCbok[assignmentId]) {
					let entries = studentCbok[assignmentId].a;
					if (entries) {
						let articleEntries = Object.keys(entries);
						articleEntries.forEach(pid => {
							cbokEntriesByArticle[pid] = entries[pid];
						});
					}
				}

				if (workspace && assignment && product && product.productType === 'AAD') {
					let options = assignment.opts || assignment.options;
					let assigned = false;
					let workspaces = [];

					if (options) {
						assigned = options.bok || options.assignBookOfKnowledge;
					}

					if (workspace && workspace.scoreState && workspace.scoreState.a) {
						let aid = workspace.aid;
						let bokWorkspaces = workspace.scoreState.a;
						let articles = Object.keys(bokWorkspaces);

						workspaces = articles.reduce((acc, pid) => {
							let articleWorkspace = bokWorkspaces[pid];
							if (articleWorkspace && (typeof articleWorkspace.b !== 'undefined' || articleWorkspace.s === 's')) {
								acc.push(
									_.assign({}, articleWorkspace, {
										pid,
										pastDue,
										aid,
										inCbok: !!cbokEntriesByArticle[pid]
									})
								);
							}
							return acc;
						}, []);
						workspaces.sort((a, b) => b.tf - a.tf);
					}

					bokAssignment = _.assign({}, workspace, {
						pmd: assignment.pmd,
						d: assignment.d,
						ed: assignment.edd || assignment.deadline,
						assigned,
						workspaces,
						inlineEdit,
						pastDue
					});
				}

				return bokAssignment;
			},
			articleList() {
				const { articleList, supplemental_texts, dteGroups } = this.product;
				let list = articleList || [];
				const { opts: assignmentOptions } = this.assignment;

				const includesSupplemental = supplemental_texts && (assignmentOptions.challenge || assignmentOptions.support);

				if (includesSupplemental) {
					for (let supplementalType in supplemental_texts) {
						if (assignmentOptions[supplementalType]) {
							list = list.concat(Object.values(supplemental_texts[supplementalType] || {}));
						}
					}
				}

				const includesDecodables = dteGroups && assignmentOptions.decodables;

				if (includesDecodables) {
					for (const dteGroup of dteGroups) {
						const assignedDecodables = new Set(assignmentOptions.decodables);
						if (assignedDecodables.has(dteGroup.id)) {
							list = [...list, ...Object.values(dteGroup.articles)];
						}
					}
				}

				return list;
			}
		}
	};
</script>
<template>
	<div
		class="main-content results-tab"
		v-bind:class="{ 'main-content-non-aad': product.productType !== 'AAD' }">
		<div
			class="well -header"
			v-if="questionSetsOrderedAndFiltered.length === 0 && product.productType !== 'AAD'">
			<h3>No questions were assigned</h3>
		</div>
		<template v-if="product.productType === 'AAD'">
			<div class="wrapper">
				<div class="result-header">
					<div class="bok-stats">
						<div>
							<div class="bok-stat">{{ articlesRead }} of {{ articleList.length }}</div>
							<div class="bok-stat-subtitle font-small text-muted">ARTICLES READ</div>
						</div>
						<div>
							<div class="bok-stat">{{ wordsRead | commaGrouping }} of {{ totalWords | commaGrouping }}</div>
							<div class="bok-stat-subtitle font-small text-muted">WORDS READ</div>
						</div>
						<div>
							<div class="bok-stat">{{ wordsWritten | commaGrouping }}</div>
							<div class="bok-stat-subtitle font-small text-muted">WORDS WRITTEN</div>
						</div>
					</div>
				</div>
				<book-of-knowledge-assignment
					v-if="bookOfKnowledgeAssignment"
					:assignment="bookOfKnowledgeAssignment">
					<div
						v-if="bookOfKnowledgeAssignment.workspaces"
						slot="entry-container"
						class="card-container">
						<book-of-knowledge-entry
							v-for="entry in bookOfKnowledgeAssignment.workspaces"
							:key="entry.aid"
							:entry="entry"
							:article="product.allArticles && product.allArticles[entry.pid]"
							:editable="!studentCbokLoading && !entry.inCbok"
							:assigned="!!bookOfKnowledgeAssignment.assigned"
							:inline-edit="editBoKInline"
							:on-edit="editBoKEntry">
							<template slot="actions-left">
								<button
									v-if="entry.inCbok"
									class="entry-promoted button -link"
									v-tooltip="'Congratulations! Your entry has been chosen for the Class Book of Knowledge.'">
									<bok-bookmark-icon></bok-bookmark-icon>
								</button>
							</template>
							<template slot="actions">
								<bok-note
									v-if="entry.tn"
									:value="entry.tn"></bok-note>
							</template>
						</book-of-knowledge-entry>
					</div>
				</book-of-knowledge-assignment>
			</div>
		</template>
		<div
			class="well -header"
			v-if="questionSetsOrderedAndFiltered.length > 1">
			<span v-if="questionsBlurb.count > 1">
				<h3>{{ questionsBlurb.blurb }}</h3>
				<tab-container
					model-key="resultsQset"
					:tabs="questionSetsOrderedAndFiltered">
					<button
						v-for="qset in questionSetsOrderedAndFiltered"
						:key="qset.qsid"
						:data-tab="qset.qsid"
						v-html="qset ? qset.title : ''"></button>
				</tab-container>
			</span>
		</div>
		<div
			class="question-set"
			v-if="questionSetsOrderedAndFiltered.length > 0"
			ref="resultsQsetPanel"
			:data-panel="qs.qsid">
			<header
				class="question-set-header grid"
				:class="{ 'non-aad': product.productType !== 'AAD' }">
				<div class="row">
					<h2 v-html="qs ? qs.title : ''"></h2>
					<h3>{{ assignedQuestions.length }} {{ assignedQuestions.length === 1 ? 'question' : 'questions' }}</h3>
					<div
						v-if="hasNote(qs.qsid) && workspace.scoreState.f && workspace.scoreState.f[qs.qsid]"
						class="columns small-12 large-4">
						<h4>Teacher Feedback</h4>
						<div class="general-feedback">
							{{ workspace.scoreState.f[qs.qsid] }}
						</div>
						<div
							v-if="hasNote(qs.qsid)"
							class="margin-top-medium margin-bottom-medium">
							<template v-for="(q, questionIndex) in assignedQuestions">
								<img
									style="cursor: pointer"
									v-on:click="scrollToNote(questionIndex)"
									v-if="workspace.scoreState.q[qs.qsid][q.qid].f"
									class="margin-right-small"
									:src="assetUrl('/assets/dist/images/icon-note-active-' + (questionIndex + 1) + '.svg')" />
							</template>
						</div>
					</div>
					<div
						v-if="summaryByQsid[qs.qsid]"
						class="columns small-12 large-8">
						<h4>
							Your Results:<br />
							<template v-if="summaryByQsid[qs.qsid].multipleChoiceQuestions.length > 0">
								Multiple Choice: {{ summaryByQsid[qs.qsid].multipleChoiceQuestionsCorrect }}/{{ summaryByQsid[qs.qsid].multipleChoiceQuestions.length }} ({{
									summaryByQsid[qs.qsid].multipleChoicePercentCorrect
								}}%)
							</template>
							<template v-if="summaryByQsid[qs.qsid].openResponseQuestions.length > 0">
								<br />
								<template v-if="summaryByQsid[qs.qsid].openResponseQuestionsAllGraded">
									Written Response: {{ summaryByQsid[qs.qsid].openResponseQuestionsCorrect }}/{{ summaryByQsid[qs.qsid].openResponseQuestionsGraded }} ({{
										summaryByQsid[qs.qsid].openResponsePercentCorrect
									}}%)
								</template>
								<template v-if="!markedDone && !summaryByQsid[qs.qsid].openResponseQuestionsAllGraded"> Written Response Needs Grading </template>
								<template
									v-if="markedDone && !summaryByQsid[qs.qsid].openResponseQuestionsAllGraded && summaryByQsid[qs.qsid].openResponseQuestionsGraded > 0">
									Written Response: {{ summaryByQsid[qs.qsid].openResponseQuestionsCorrect }}/{{ summaryByQsid[qs.qsid].openResponseQuestionsGraded }} ({{
										summaryByQsid[qs.qsid].openResponsePercentCorrect
									}}%)
								</template>
							</template>
							<template v-if="summaryByQsid[qs.qsid].openResponseQuestionsGraded && product.questionSets[qs.qsid].questions.length > 0">
								<br />
								Total:
								{{ summaryByQsid[qs.qsid].totalCorrect }}/{{
									summaryByQsid[qs.qsid].openResponseQuestionsGraded + summaryByQsid[qs.qsid].multipleChoiceQuestions.length
								}}
								({{ summaryByQsid[qs.qsid].percentTotalCorrect }}%)
							</template>
						</h4>
					</div>
				</div>
			</header>
			<!-- end .question-set-header -->
			<div
				class="directions"
				v-if="qs.studentIntro"
				v-html="qs.studentIntro"></div>
			<template v-if="qs.studentIntroImages">
				<vocabulary-image-list
					:images="qs.studentIntroImages"
					:word="qs.vocabularyWord">
				</vocabulary-image-list>
			</template>
			<ol class="question-set-questions -student grid">
				<li
					v-for="(q, questionIndex) in assignedQuestions"
					:key="q.qid"
					class="row"
					:data-note="questionIndex">
					<div class="columns small-12 large-8">
						<student-workspace-question
							disable-input
							v-bind:q="q"
							v-bind:qsid="qs.qsid"
							v-bind:aid="assignmentId"
							v-bind:score-state.sync="workspace.scoreState.q[qs.qsid][q.qid]"
							v-bind:grade="
								scoredQuestionSets && scoredQuestionSets[qs.qsid] && scoredQuestionSets[qs.qsid][q.qid] ? scoredQuestionSets[qs.qsid][q.qid] : {}
							"
							v-bind:ws="workspace"
							v-bind:qnumb="questionIndex + 1"></student-workspace-question>
					</div>
					<div
						class="columns small-12 large-4"
						v-if="workspace.scoreState.q[qs.qsid][q.qid].f">
						<img :src="assetUrl('/assets/dist/images/icon-note-active-' + (questionIndex + 1) + '.svg')" />
						<span>{{ workspace.scoreState.q[qs.qsid][q.qid].f }}</span>
					</div>
				</li>
			</ol>
			<!-- end .question-set-questions -->
			<template v-if="!atLastQuestionSet">
				<a
					class="button -large"
					v-on:click.prevent="nextQuestionSet()"
					>Next &rarr;</a
				>
			</template>
		</div>
		<!-- end .question-set -->
	</div>
</template>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.results-tab {
		.result-header {
			margin-bottom: 1rem;

			.bbok-badge-icon {
				margin-right: 1rem;
			}

			.bbok-link,
			.bok-stats {
				display: block;
			}

			.bbok-link {
				margin-bottom: 0.5rem;
				font-weight: 500;
			}
		}

		.question-set-questions li .columns {
			padding-top: 2em;
		}

		.question-set-questions li .columns:nth-of-type(2) {
			border-bottom: 1px solid $c-grey;
		}

		.question-set-header {
			border-bottom: 1px solid $c-grey;
		}

		table.aad th,
		table.aad td {
			vertical-align: top;
		}

		table.aad .timestamp {
			text-align: right;
			text-transform: uppercase;
			white-space: nowrap;

			.submitted-title {
				text-transform: none;
			}
		}

		.card-container {
			> .bok-entry {
				margin-right: 1.5rem;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.results-tab {
			.result-header {
				display: flex;
				flex-wrap: wrap;
				align-items: center;

				.bbok-link {
					flex: 1;
				}

				.bok-stats {
					flex: 1;
				}
			}

			.main-content-non-aad {
				margin-left: 2rem;
			}
		}
	}

	@media only screen and (min-width: $bp-width-lg) {
		.results-tab {
			&.main-content-non-aad {
				margin-left: 14rem;
			}

			.question-set-questions li .columns:nth-of-type(2) {
				border-bottom: none;
			}

			.question-set-questions li .columns:first-of-type {
				border-bottom: 1px solid $c-grey;
			}
		}
	}
</style>
